import React from 'react';
import Head from '../components/head'
import Body from '../components/body'
import Footer from '../components/footer'
import IframeComponent from '../components/iframecom';
import { BrowserRouter as Router,Switch,Route } from "react-router-dom";
export default class Routes extends React.Component {
render() {
    return (
      <div className="B-da">
        <Router>
        <Head checkvalue={false}/>
           <Switch>
            <Route exact path="/">
              <Body/>
            </Route>
            <Route exact path="/view">
            <IframeComponent name="http://housing.auctionsoftware.com" webname="Housing"/>
            </Route>
            <Route exact path="/view1">
            <IframeComponent name="https://antique.auctionsoftware.com/en/" webname="Antique"/>
            </Route>
            <Route exact path="/view2">
            <IframeComponent name="https://speedbid.auctionsoftware.com/" webname="Speedbid"/>
            </Route>
            <Route exact path="/view3">
            <IframeComponent name="https://cars.auctionsoftware.com/" webname="Carbid"/>
            </Route>
            <Route exact path="/view4">
            <IframeComponent name="https://pennydemo1.auctionsoftware.com/" webname="Pennydemo1"/>
            </Route>
            <Route exact path="/view5">
            <IframeComponent name="https://reverse.auctionsoftware.com/" webname="Reverse"/>
            </Route>
            {/* <Route name="pass" exact path="/view">
               <IframeComponent/>
            </Route>
             */}
         </Switch> 
        </Router>
        <Footer/>
      </div>
    );
  }
}
